// src/App.js
import '@aws-amplify/ui-react/styles.css';
import { Route, Routes } from 'react-router-dom'; // <-- no BrowserRouter here
import './App.css';

import Home from './Home.jsx';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import CleanTruck from './CleanTruck.jsx';
import UpdatedStats from './UpdatedStats.jsx';
import AdminDash from './AdminDash.jsx';
import Approvals from './Approvals.jsx';
import RequireGroup from './auth/RequireGroup.jsx';

export default function App({ user, onSignOut }) {
  return (
    <div>
      <Header user={user} onSignOut={onSignOut} />
      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="/detailing"
          element={
            <RequireGroup anyOf={['detailer']} fallback={<div style={{ padding: 16 }}>Checking your access…</div>}>
              <CleanTruck />
            </RequireGroup>
          }
        />

        <Route path="/performance" element={<UpdatedStats />} />

        <Route
          path="/admin"
          element={
            <RequireGroup anyOf={['management']} fallback={<div style={{ padding: 16 }}>Checking your access…</div>}>
              <AdminDash />
            </RequireGroup>
          }
        />

        <Route path="/approve" element={<Approvals />} />
      </Routes>
      <Footer />
    </div>
  );
}
